import { Image } from "@wayflyer/flyui";
import { styled } from "styled-components";

export const SmallImage = styled(Image)`
  height: 24px;
`;
